var ShapeEnum;
(function (ShapeEnum) {
    ShapeEnum["CIRCLE"] = "circle";
    ShapeEnum["RECTANGLE"] = "rectangle";
    ShapeEnum["POLYGON"] = "polygon";
    ShapeEnum["WELL"] = "well";
    ShapeEnum["ROI"] = "roi";
})(ShapeEnum || (ShapeEnum = {}));
export default ShapeEnum;
